import { generateTableSlice } from "./tableSlice";

const sliceUserTable = generateTableSlice("user");

export const ActionsUserTable = sliceUserTable.actions;
export const ReducerUserTable = sliceUserTable.reducer;
